import { z } from "zod";
import { UserInvitationType } from "./types";
import { CivilStatus } from "../../../enums/civil-status";
import { Gender } from "../../../enums/gender";

export const RoleModelSchema = z.object({
    id: z.string().nonempty("Role ID is required."),
    name: z.string().nonempty("Role name is required."),
    displayName: z.string().nonempty("Role name is required."),
    role: z.string(),
});

export const userInvitationSchema = z
    .object({
        type: z.nativeEnum(UserInvitationType, { required_error: "Type is required" }),
        email: z.string().optional(),
        firstName: z.string().optional(),
        lastName: z.string().optional(),
        productCode: z.string().optional(),
        facilityCode: z.string().optional(),
        userId: z.string().optional(),
        // role: RoleModelSchema,
    })
    .refine(
        (data) => {
            if (data.type === UserInvitationType.Email) {
                return !!data.email;
            }
            return true;
        },
        {
            message: "Email is required.",
            path: ["email"],
        }
    )
    .refine(
        (data) => {
            if (data.email) {
                return z.string().email().safeParse(data.email).success;
            }
            return true;
        },
        {
            message: "Invalid email address.",
            path: ["email"],
        }
    )
    .refine(
        (data) => {
            if (data.type === UserInvitationType.UserFullname) {
                return !!data.firstName;
            }
            return true;
        },
        {
            message: "Please input first name.",
            path: ["firstName"],
        }
    ).refine(
        (data) => {
            if (data.type === UserInvitationType.UserFullname) {
                return !!data.lastName;
            }
            return true;
        },
        {
            message: "Please input last name.",
            path: ["lastName"],
        }
    );

export const userFormSchema = z.object({
    id: z.string().optional(),
    lastName: z.string().nonempty("Required"),
    firstName: z.string().nonempty("Required"),
    middleName: z.string().optional(),
    suffix: z.string().optional(),
    prefix: z.string().optional(),
    customName: z.string().optional(),
    email: z.string().email("Required"),
    civilStatus: z
    .number(), 
    gender: z
    .number(),
    productCode: z.string().optional(),
    facilityCode: z.string().optional(),
    role: RoleModelSchema,
    clientIds: z.array(z.string()).optional(),


   birthDate: z
    .string()
    .optional()
    .refine(
        (d) => !d || !isNaN(Date.parse(d)),
        { message: "Invalid date format" }
    )
    .refine(
        (d) => !d || new Date(d) <= new Date(),
        { message: "Date should not be in the future" }
    ),
    photoUrl: z.any().optional(),
    isDefaultPassword: z.boolean().optional(),
    department: z.number().optional(),
});



export type UserSchema = z.infer<typeof userInvitationSchema>;
export type UserFormSchema = z.infer<typeof userFormSchema>;

